const setMis = data => ({
  type: 'SET_MIS_DATA',
  payload: data,
});

export { setMis };
